import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { SearchPageCounterPaginationComponent } from './search-page-counter-pagination.component';

@NgModule({
  imports: [CommonModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SearchPageCounterPagination: {
          component: SearchPageCounterPaginationComponent,
        },
      },
    }),
  ],
})
export class SearchPageCounterPaginationModule {}
